import LazyLoad from './../library/LazyLoad';

export default class Guides {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Guides;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		window.site.animateGuides = function() {
			const lazyLoad = new LazyLoad();
			lazyLoad.fadeInStaggerElement('.js-guide-results, .js-guide-pagination');
		};

		$(document).on('click', '.js-guides-pagination', function(e) {
			e.preventDefault();
			self.loadPage($(this).data('page'));
		});

		$(document).on('click', '.js-guides-category', function(e) {
			e.preventDefault();
			self.loadCategory($(this).data('category'));
		});

		$(document).on('submit', '.js-guides-search', function(e) {
			e.preventDefault();
			self.loadByKeywords($(this).find('input[name="query"]').val());
		});
	}

	loadPage(page) {
		const self = this,
			$form = $('.js-guides-form');

		$form.find('input[name="page"]').val(page);
		$form.submit();
	}

	loadCategory(category) {
		const self = this,
			$form = $('.js-guides-form');

		$('.js-guides-category').parent('li').removeClass('is-active');
		$('.js-guides-category[data-category="' + category + '"]').parent('li').addClass('is-active');

		$form.find('input[name="categoryId"]').val(category);
		$form.find('input[name="page"]').val(1);
		$form.submit();
	}

	loadByKeywords(query) {
		const self = this,
			$form = $('.js-guides-form');

		$form.find('input[name="query"]').val(query);

		self.loadCategory('all');
	}
}
